import React from 'react'

const NotFoundSvg = ({ size = 150 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={size}
            height={size}
            x={0}
            y={0}
            viewBox="0 0 64 64"
            style={{ enableBackground: "new 0 0 512 512" }}
            xmlSpace="preserve"
            fillRule="evenodd"
            className=""
        >
            <g>
                <path
                    fill="#565ad3"
                    d="M42.251 31.697 31.644 42.303s3.772-1.178 9.193.707c.912.317 2.438-1.209 2.121-2.121-1.885-5.421-.707-9.192-.707-9.192z"
                    opacity={1}
                    data-original="#347bfa"
                    className=""
                />
                <path
                    fill="#e9f3fc"
                    d="M13.864 13.916c6.44-6.439 16.895-6.439 23.335 0 6.439 6.44 6.439 16.895 0 23.335-6.44 6.439-16.895 6.439-23.335 0-6.439-6.44-6.439-16.895 0-23.335z"
                    opacity={1}
                    data-original="#e9f3fc"
                />
                <path
                    fill="#cadcf0"
                    d="M35.066 12.114a16.702 16.702 0 0 1 2.133 1.802c6.439 6.44 6.439 16.895 0 23.335-6.44 6.439-16.895 6.439-23.335 0-.379-.38-.736-.773-1.071-1.178 6.242 2.028 13.376.564 18.332-4.392 5.286-5.286 6.6-13.05 3.941-19.567z"
                    opacity={1}
                    data-original="#cadcf0"
                />
                <path
                    fill="#a4bbdb"
                    d="M12.45 12.502c7.22-7.22 18.943-7.22 26.163 0s7.22 18.943 0 26.163-18.943 7.22-26.163 0-7.22-18.943 0-26.163zm2.121 2.121c6.049-6.049 15.872-6.049 21.921 0s6.049 15.872 0 21.921-15.872 6.049-21.921 0-6.049-15.872 0-21.921z"
                    opacity={1}
                    data-original="#a4bbdb"
                />
                <path
                    fill="#b9cae3"
                    d="M8.957 33.81c-3.432-6.919-2.268-15.547 3.493-21.308 5.41-5.41 13.348-6.766 20.027-4.068a23.842 23.842 0 0 1 .029 3.304c-5.811-2.926-13.085-1.964-17.935 2.885-5.141 5.141-5.913 13.008-2.314 18.968-1.054.144-2.13.219-3.222.219z"
                    opacity={1}
                    data-original="#b9cae3"
                />
                <path
                    fill="#a4bbdb"
                    d="M40.027 46.443a4.5 4.5 0 0 1 6.364-6.364l14.496 14.496c.39.39-.719 2.133-2.475 3.889s-3.499 2.865-3.889 2.475z"
                    opacity={1}
                    data-original="#a4bbdb"
                />
                <path
                    fill="#cadcf0"
                    d="M40.027 46.443a4.5 4.5 0 0 1 6.364-6.364l13.12 13.12c.39.39-.719 2.133-2.475 3.889s-3.499 2.865-3.889 2.475z"
                    opacity={1}
                    data-original="#cadcf0"
                />
                <g fill="#347bfa">
                    <path
                        d="M23.413 22.435c-.023-.953.335-1.649.887-2.057.868-.64 2.165-.613 2.869.18.302.341.477.823.482 1.433.012 1.463-.674 2.318-1.346 3.203-.904 1.193-1.807 2.419-1.919 4.466a1 1 0 0 0 1.998.109c.084-1.555.828-2.461 1.515-3.367.92-1.213 1.769-2.423 1.752-4.427-.01-1.178-.403-2.087-.987-2.745-1.364-1.536-3.869-1.702-5.551-.462-1.008.744-1.741 1.976-1.7 3.714a1 1 0 0 0 2-.047z"
                        fill="#565ad3"
                        opacity={1}
                        data-original="#347bfa"
                        className=""
                    />
                    <circle
                        cx="25.292"
                        cy="33.197"
                        r="1.23"
                        fill="#565ad3"
                        opacity={1}
                        data-original="#347bfa"
                        className=""
                    />
                    <path
                        d="m43.288 8.497 3-5a1 1 0 1 0-1.715-1.029l-3 5a1 1 0 0 0 1.715 1.029zM48.019 11.792l11-8a1 1 0 0 0-1.176-1.618l-11 8a1 1 0 0 0 1.176 1.618zM49.673 17.953l8-2a1 1 0 1 0-.485-1.94l-8 2a1 1 0 0 0 .485 1.94z"
                        fill="#565ad3"
                        opacity={1}
                        data-original="#347bfa"
                        className=""
                    />
                </g>
            </g>
        </svg>

    )
}

export default NotFoundSvg